export default __webpack_public_path__ + "static/genial-96826bfa687c4b3af19aadca9f148d56.svg";